// Calls fn once per page load and shares its promise; a failure clears it so the next call retries.
export const cacheOnce = (fn) => {
  let promise;
  return () => {
    if (!promise) {
      promise = fn().catch((error) => {
        promise = undefined;
        throw error;
      });
    }
    return promise;
  };
};
